import React, { useEffect, useState } from 'react';
import Procedures from './Procedures/Procedures';
import DashboardNewProc from './Dash board new proc/DashboardNewProc';
import ListOfUser from './List Of User/ListOfUser';
// import ListofOrganization from "./List of Organization/ListofOrganization";
import Layout from '../layout/Layout';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import TabsPanel from '../tabs/TabsPanel';
import ListOfOrganization from './List of Organization/ListofOrganization';
import { api } from '../../Api-Endpoints/apiEndpoint';
import { userLoginSuccess } from '../../Redux/OauthSlice';
import { LoadProceduresRequestFalse } from '../../Redux/ProcedureReducer';
import Loader from '../Butten/Loader';
const Dashboard = () => {
  const dispatch = useDispatch();
  const { organizations, _roles, user, users, proceduresLength } = useSelector(
    state => ({
      proceduresLength: state.Procedure?.procedures?.length,
      organizations: state.Organization.organizations,
      _roles: state.Roles._roles,
      user: state.User.user,
      users: state.Users.users,
    }),
    shallowEqual
  );
  const navigate = useNavigate();
  useEffect(() => {
    const loggedInUser = JSON.parse(localStorage.getItem('auth'));
    const lastRoute = localStorage.getItem('lastRoute');
    getProceduresByUserAdmin();
    dispatch(userLoginSuccess(loggedInUser));
    if (!loggedInUser?.role?.includes('admin')) {
      getProceduresByUserId();
      navigate('/procedures');
    }
  }, []);

  const [proceduresItems, setProcedureItems] = useState([]);
  const [proceduresCount, setProceduresCount] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getProceduresByUserId = async () => {
    const userDetails = JSON.parse(localStorage.getItem('auth'));
    const id = userDetails?._id;
    const { data } = await api.get(`/procedure/getProcedureById/${id}`);
    const userProcedures = data?.procedures[0]?.procedures || [];
    setProcedureItems(userProcedures);
  };
  const getProceduresByUserAdmin = async () => {
    const userDetails = JSON.parse(localStorage.getItem('auth'));
    setIsLoading(true);
    const { data } = await api.get(`/procedure/total/count/for/admin`);
    setProceduresCount(data.count);
    setIsLoading(false);
  };
  return (
    <>
      <Layout heading={'Dashboard'} isDashboardClick={true}>
        <div className="h-[87vh] overflow-y-scroll">
          <div className="w-[81vw]">
            <DashboardNewProc />
          </div>
          {/* <Link to={'/user-dashboard'}>User Dashboard</Link> */}

          <div className="min-h-[67vh] w-[100%]">
            <div className="w-[100%] flex gap-2 justify-between">
              <TabsPanel
                title={'Roles'}
                btnText={'View'}
                length={user.role == 'admin' ? _roles.length : 1}
              />
              <TabsPanel
                title={
                  // isLoading ? ' ' : 'Procedures'
                  'Procedures'
                }
                btnText={'View'}
                length={
                  // isLoading ? <Loader message=" "></Loader> : proceduresCount
                  proceduresLength
                }
              />
              <TabsPanel
                title={'Organizations'}
                btnText={'View'}
                length={organizations?.length}
              />
              {user.role == 'admin' && (
                <TabsPanel
                  title={'Users'}
                  btnText={'View'}
                  length={users.length}
                />
              )}
            </div>

            <div className="h-min-[47vh] w-[100%] flex mt-3">
              <ListOfOrganization organizations={organizations} />
              <ListOfUser />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Dashboard;
